import { createSelector } from 'reselect';
import { RootState } from '@reducers';
import { FhqSitesState } from '@reducers/fhqs';

export const getFhqs = (state: RootState): FhqSitesState => state.fhqs;
export const getFhqsData = createSelector(getFhqs, (fhqs) => fhqs?.data);
export const isFhqsLoading = createSelector(getFhqs, (fhqs) => fhqs?.loading);
